import { useStore } from 'hooks/useStore';
import { unconstrainedForecastService } from 'services/fdp/unconstrainedForecastService';

export function useUploadExcelModal(onClose: () => void) {
  const { UnconstrainedForecastViewStore: store } = useStore();

  const handleDownloadTemplate = () => {
    unconstrainedForecastService.downloadUploadTemplate().catch(() => {
      // toast is handled by the service layer error; nothing else needed here
    });
  };

  const handleUploadFile = (file: File) => {
    store.handleUploadFile(file);
  };

  return {
    isUploadingFile: store.isUploadingFile,
    uploadFileError: store.uploadFileError,
    uploadColumnErrors: store.uploadColumnErrors,
    handleDownloadTemplate,
    handleUploadFile,
    handleClose: onClose,
  };
}
